import Icon from 'components/atoms/Icon';
import { AssessmentStageFragmentFragment } from 'generated/graphql';
import { useState } from 'react';
import { Button, TextInputField } from '@spotted-zebra-uk/ui-components';
import EditAiInterviewActionModal from './EditAiInterviewActionModal';

type AiInterviewAction = NonNullable<
  AssessmentStageFragmentFragment['actions']['aiInterview']
>;

interface IStageAiInterviewAction {
  aiInterviewAction: AiInterviewAction;
  projectId: number;
}

const StageAiInterviewAction = ({
  aiInterviewAction,
  projectId,
}: IStageAiInterviewAction) => {
  const [isConfigModalOpen, setIsConfigModalOpen] = useState(false);

  const durationInMinutes = Math.round(aiInterviewAction.duration / 60);
  const displayLabel = `${aiInterviewAction.name} (${durationInMinutes} min)`;

  return (
    <div
      className="stage-ai-interview-action"
      data-testid="edit-project__stage-ai-interview-action"
    >
      <Icon icon="ai_interview" className="stage-ai-interview-action__icon" />
      <TextInputField
        id={`ai-interview-action-${aiInterviewAction.id}`}
        disabled
        onChange={() => {}}
        value={displayLabel}
        className="stage-ai-interview-action__name-label"
      />
      <Button
        variant="secondary"
        size="small"
        className="stage-ai-interview-action__config-button"
        data-testid="stage-ai-interview-action__config-button"
        onClick={() => setIsConfigModalOpen(true)}
        aria-label="Configure AI interview"
      >
        <Icon
          icon="settings"
          className="stage-ai-interview-action__config-button-icon"
        />
      </Button>
      {isConfigModalOpen && (
        <EditAiInterviewActionModal
          aiInterviewAction={aiInterviewAction}
          projectId={projectId}
          onClose={() => setIsConfigModalOpen(false)}
        />
      )}
    </div>
  );
};

export default StageAiInterviewAction;
